import { authAxiosClient } from '@/lib';
import { PaginatedApiResponse, PaginatedData } from '@/types';
import { withLogger } from '@/utils';

import { experiencesAPIUrls } from '../data';
import { Ticket } from '../types';

type Param = {
  searchString: string;
  status: Array<Ticket['status']>;
  page: number;
  rowsPerPage: number;
};

type Tickets = Array<Ticket>;
type Return = PaginatedData<Array<Ticket>>;

export type GetTickets = {
  param: Param;
  return: Return;
};

export const getTickets = withLogger(
  async ({
    searchString: search,
    status,
    page,
    rowsPerPage: per_page,
  }: Param): Promise<Return> => {
    const {
      data: { data },
    } = await authAxiosClient.get<PaginatedApiResponse<Tickets>>(
      experiencesAPIUrls.getTickets,
      {
        params: {
          search,
          status,
          page,
          per_page,
        },
      },
    );
    return data;
  },
);
